import { useEffect } from 'react';
import { PromotionPageLayout } from '@/components/layout/PromotionPageLayout';
import { HeroSection } from './sections/HeroSection';
import { WhyThisExistsSection } from './sections/WhyThisExistsSection';
import { HowItWorksSection } from './sections/HowItWorksSection';
import { CurriculumTracksSection } from './sections/CurriculumTracksSection';
import { TeacherSection } from './sections/TeacherSection';
import { TestimonialSection } from './sections/TestimonialSection';
import { FaqSection } from './sections/FaqSection';
import { FinalCtaSection } from './sections/FinalCtaSection';
import { FooterSection } from './sections/FooterSection';
import { useImagePreloader } from '@/hooks/useImagePreloader';
import { COLLAGE_IMAGES } from '@/constants/promotionImages';
import serverWarmupService from '@/services/serverWarmupService';

export default function PromotionLanding() {
  useImagePreloader(COLLAGE_IMAGES);
  useEffect(() => { serverWarmupService.pingServer(); }, []);

  return (
    <PromotionPageLayout showCollage={false}>
      <HeroSection />
      <WhyThisExistsSection />
      <HowItWorksSection />
      <CurriculumTracksSection />
      <TeacherSection />
      <TestimonialSection />
      <FaqSection />
      <FinalCtaSection />
      <FooterSection />
    </PromotionPageLayout>
  );
}